import { CategoryChartQueryFn, CategoryChartQueryParam } from "../categoryChart";
import { FigureHorStackBarKpiProviders } from "./categoryChartData.types";
import { fetchFigureHorStackBarKpiComparisonChartData } from "./fetchFigureHorStackBarKpiComparisonChartData";
import { computeVolumeWaterSourcedChartData } from "./fetchFigureHorStackBarVolumeWaterSourcedChartData";

export const fetchFigureHorStackBarVolumeWaterSourcedComparisonChartData: CategoryChartQueryFn = async ({
    categoryChart,
    providers,
    kpis,
    category,
    ...rest
}: CategoryChartQueryParam): Promise<FigureHorStackBarKpiProviders> => {
    if (!providers || !providers.length || !categoryChart || kpis == null || !kpis?.length) return null;

    const data = (await fetchFigureHorStackBarKpiComparisonChartData({
        categoryChart,
        providers,
        kpis,
        category,
        ...rest
    })) as FigureHorStackBarKpiProviders;

    data?.waterProviders?.forEach((provider, index) => {
        const providerData = data?.elements?.[index];

        if (providerData != null) {
            // recompute visuals and update figure and graph after
            const computedVisualData = computeVolumeWaterSourcedChartData(provider, kpis, {
                ...providerData,
                unit: data?.unit
            });

            providerData.figure = computedVisualData.figure;
            providerData.graph = computedVisualData.graph;
        }
    });

    return data;
};
